import { CartItem } from './cart-item';
import { CartItemSummary } from './cart-item-summary';
import { Deserializable } from "./deserializable";

export class Cart {
    cartUid: string;
    userId?: number;
    cartItems: CartItem[] = [];
    cartItemSummaries: CartItemSummary[] = [];
    createdDateTime: Date;
    promoCode: string;
    promoDescription: string;
    promoCodeDiscount: number;
    lastModifiedDateTime: Date;
    subtotalAmount: number;
    totalAmount: number;
    warningMessage: string;

    deserialize(input: any) {
        Object.assign(this, input);
        this.populateCartItemSummaries();

        this.cartItems = [];

        for (let i = 0; i < input.cartItems.length; i++) {
            this.cartItems.push(new CartItem().deserialize(input.cartItems[i]));
        }

        return this;
    }

    public getTotalItemCount(): number {
        if (this.cartItems == null) {
            return 0;
        }

        let total = 0;
        for (const cartItem of this.cartItems) {
            total += cartItem.quantity;
        }

        return total;
    }

    private populateCartItemSummaries(): void {
        (function groupSum(cart) {
            const output = cart.cartItems.reduce(function(left, right) {
                const key = `${right.eventPerformerExperienceId}|${right.eventPerformerName}|${right.experienceName}|${right.maxPurchaseLimit}|${right.eventName}|${right.eventDate}`;
                left.quantity[key] = (left.quantity[key] || 0) + right.quantity;
                left.totalAmount[key] = (left.totalAmount[key] || 0) + (right.quantity * right.price);
                return left;
            }, {quantity: {}, totalAmount: {}});

            cart.cartItemSummaries = Array.from(new Set(Object.keys(output.quantity).concat(Object.keys(output.totalAmount)))).map(function(x) {
                const keys = x.split('|');

                const cartItemSummary = new CartItemSummary();
                cartItemSummary.eventPerformerExperienceId = +keys[0];
                cartItemSummary.eventPerformerName = keys[1];
                cartItemSummary.experienceName = keys[2];
                cartItemSummary.maxPurchaseLimit = +keys[3];
                cartItemSummary.eventName = keys[4];
                cartItemSummary.eventDate = new Date(keys[5]);
                cartItemSummary.quantity = output.quantity[x];
                cartItemSummary.totalAmount = output.totalAmount[x];

                return cartItemSummary;
            });
        })(this);
    }

    public groupedCartItemSummaries() : any {
        return this.cartItemSummaries.reduce(function(rv, x) {
            (rv[x["eventName"]] = rv[x["eventName"]] || []).push(x);
            return rv;
        }, {});
    }
}



// WEBPACK FOOTER //
// ./src/app/_models/cart.ts